module.exports = __webpack_public_path__ + "img/finishicon.82d62bf4.svg";